export enum PriavaEnvironmentType {
    Production = 1,
    Sandbox = 2,
    Staging = 3,
    Dev = 4
}